import { ActionReducer, MetaReducer } from '@ngrx/store';
import * as fromAuthActions from '../actions/auth.actions';
import { AppState } from '../app.state';

export function clearStateMetaReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return function (state, action) {
    if (action.type === fromAuthActions.autoLogout.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearStateMetaReducer];